import dayjs from 'dayjs';

export const parseSelectedToIso = (params: {
  startPoint: number | undefined;
  comparisonDate: Date | null;
  comparisonType: string;
  compareTo: string;
  compareToUnit: string;
}): string => {
  const { startPoint, comparisonDate, comparisonType, compareTo, compareToUnit } = params;
  let selectedDateString = '';
  if (comparisonDate && comparisonType === 'absolute') {
    selectedDateString = dayjs(comparisonDate).format('YYYY-MM-DD');
  }
  if (compareTo.length > 0 && comparisonType === 'relative') {
    const relativeDate = parseRelativeDateSelection(Number(compareTo), compareToUnit, startPoint);
    selectedDateString = dayjs(relativeDate).format('YYYY-MM-DD');
  }
  return selectedDateString;
};

export const parseRelativeDateSelection = (
  compareTo: number,
  compareToUnit: string,
  startPoint?: number
) => {
  let today = new Date();
  if (startPoint) {
    today = new Date(startPoint);
  }
  switch (compareToUnit) {
    case 'd': {
      today.setDate(today.getDate() - compareTo);
      break;
    }
    case 'm': {
      today.setMonth(today.getMonth() - compareTo);
      break;
    }
    case 'y': {
      today.setFullYear(today.getFullYear() - compareTo);
      break;
    }
    case 'mtd': {
      const targetMonth = today.getMonth() - compareTo + 1;
      today.setMonth(targetMonth, 1);
      today.setUTCHours(0, 0, 0, 0);
      break;
    }

    // ✅ NEW: Year-to-date
    case 'ytd': {
      const targetYear = today.getFullYear() - compareTo + 1;
      today.setFullYear(targetYear, 0, 1);
      today.setUTCHours(0, 0, 0, 0);
      break;
    }
  }
  return today;
};
